module.exports = __webpack_public_path__ + "static/media/Mountain2M.a29857f8.gif";